import API from "../../../utils/api";


export const getFeatureLabelApi = async (filters) => {
    const response = await API.get(`settings/feature-label`, { params: filters });
    return { response };
};

export const addFeatureLabelApi = async (data) => {
    const response = await API.post(`settings/feature-label`, data, { "content-type": "multipart/form-data" });
    return { response };
};

export const updateFeatureLabelApi = async (data, id) => {
    const response = await API.post(`settings/feature-label/${id}`, data, { "content-type": "multipart/form-data" });
    return { response };
}

export const deleteFeatureLabelApi = async (id) => {
    const response = await API.delete(`settings/feature-label/${id}`);
    return { response };
}
